import React from "react";

import { BADGE_VIDEO } from "@/mk/autogenerated/translations/YoutubeEmbed.b49fbe859a43a88796f7187c1899e9fd";

import styles from "./YoutubeEmbed.mscss";

export const YoutubeEmbed = ({ className, width, height, src }) => {
    return (
        <div className={styles.YoutubeEmbed}>
            <iframe
                {...({ loading: "lazy" } as any)}
                title={BADGE_VIDEO}
                width={width}
                height={height}
                src={src}
                frameBorder="0"
                allowFullScreen
                className={className}
            />
        </div>
    );
};
